import { Component, input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-flow-node-inputs',
    templateUrl: './flow-node-inputs.component.html',
    styleUrl: './flow-node-inputs.component.scss',
    standalone: false,
})
export class FlowNodeInputsComponent {
    public inputs = input.required<{ id: string; label?: string }[]>();
}
